import { LitElement, html, css } from 'lit';
import { validateForm, gRecaptcha, hideRevealPassword } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
import { eyeSvg } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInLoginForm extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        alreadyLoggedInMessage: { type: String },
        loggedIn: { type: String },
        redirect: { type: String },
        _successMessage: { state: true },
        _errorMessage: { state: true },
        _loginSuccess: { state: true },
        _submitting: { state: true },
    };
    constructor() {
        super();
        this._loginSuccess = false;
        this._errorMessage = '';
        this._submitting = false;
        if (!this.redirect) {
            this.redirect = '/';
        }
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.loggedIn == 'true' && this.redirect && this.redirect !== '/') {
            window.location.href = this.redirect;
        }
        this.eventManager = new EventManager(this);
    }
    get form() {
        return this.shadowRoot.querySelector('form');
    }
    get error() {
        return this.shadowRoot.querySelector('.error');
    }
    get success() {
        return this.shadowRoot.querySelector('.success');
    }
    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }
    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
    render() {
        return html ` \n            <div class="login-form">\n                <slot name="login-form-header"></slot>\n                ${this.loggedIn === 'true'
            ? html `<p>${this.alreadyLoggedInMessage}</p>` : html `\n                    <form action="${this.action}" method="post" @submit=${this._login}>\n                        <div class="form_inner ${this._loginSuccess ? 'hide' : ''}" >\n                            <div class="message notice" aria-live="polite"></div>\n                            <div class="input-group">\n                                <label for="email">E-bost</label>\n                                <input type="email" name="email" id="email" placeholder="E-bost" aria-required>\n                            </div>\n                            <input type="text" name="login" id="login" class="hp" autocomplete="off">\n                            <div class="input-group">\n                                <label for="password">Cyfrinair</label>\n                                <div class="pword_wrapper">\n                                    <input type="password" name="password" id="password" placeholder="Cyfrinair" aria-required>\n                                    <button data-switch="password" aria-label="Dangos cyfrinair" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                                    ${eyeSvg}Dangos cyfrinair</button>\n                                </div>\n                            </div>\n                            <input type="submit" value="Mewngofnodi">\n                        </div>\n                        <div class="notice" aria-live="assertive">\n                            <div class="${this._errorMessage ? '' : 'hide'} error"></div>\n                            <div class="${this._loginSuccess ? '' : 'hide'} success"></div>\n                            <slot name="login-success" class="${this._loginSuccess ? '' : 'hide'} success"></slot>\n                        </div>\n                        <div class="${this._loginSuccess ? 'hide' : ''}">\n                            <slot></slot>\n                        </div>\n                    </form>\n                `}\n            </div>\n        `;
    }
    async _login(e) {
        e.preventDefault();
        //block duplicates calls to rest.php
        if (this._submitting)
            return;
        this._submitting = true;
        this._errorMessage = '';
        let valid = validateForm(this.form, this.formResponse);
        if (!valid) {
            this._submitting = false;
            return;
        }
        let formData = new FormData(this.form);
        formData = JSON.stringify(Object.fromEntries(formData));
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        /*  let gTokenValid  = await gRecaptcha(this.formResponse,this.action,this.nonce);
         if(!gTokenValid){
             this.form.classList.remove('loading');
             this.form.setAttribute('aria-busy', 'false');
             this.submitButton.disabled = false;
             this._submitting = false;
             return;
         } */
        let response = await fetch(this.action, {
            method: 'POST',
            body: formData,
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': this.nonce,
                'AllIn-Login': 'login',
            }
        });
        try {
            response = await response.json();
            if (response.ok) {
                /* this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this._loginSuccess = true;
                this.success.innerHTML = response.message; */
                this._dispatchLoginEvent(response.name);
                if (!this.redirect) {
                    window.location.href = response.redirect;
                }
                else {
                    window.location.href = this.redirect;
                }
            }
            else {
                this.error.innerHTML = response.message;
                this._errorMessage = true;
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
        }
        this._submitting = false;
    }
    _dispatchLoginEvent(name) {
        this.eventManager.emit('allin-login', { loggedIn: true, name: name });
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            .login-form{
                background-color:var(--allin-bg-color,transparent);
                padding:var(--allin-padding,2rem);
                width:680px;
                max-width:85vw;
                margin:0 auto;
                box-sizing:border-box;
            }

        `
    ];
}
